import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // ⛔ KOTAKNYA TETAP 16px, AREA SENTUHNYA yang dilebarkan jadi 44px.
      //
      // STANDAR_UI §E3 mewajibkan 44×44px. Membesarkan kotaknya sendiri ke
      // 44px akan membuat centang sebesar tombol — jelek, dan mengubah tiap
      // layar yang memakainya. Pseudo-element `before` menyelesaikan
      // keduanya: yang dilihat 16px, yang bisa ditekan 16+28 = 44px.
      //
      // ⚠ `md:before:content-none` mencabutnya di desktop. Area tak terlihat
      //    selebar 44px di layar padat akan MENCURI klik milik elemen
      //    sebelahnya — pagar yang menolong jempol bisa mengganggu tetikus.
      "peer relative h-4 w-4 shrink-0 rounded-sm border border-primary shadow " +
      "before:absolute before:-inset-[14px] before:content-[''] md:before:content-none " +
      "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      className
    )}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
